"use client";

import { ChevronRight, Plus, X } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Services() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const strategyServices = [{
    id: "01",
    title: "Audit di Comunicazione",
    description: "Capire cosa funziona, cosa confonde e dove intervenire prima.",
    details: "Report sintetico, priorità concrete e call di 30 minuti.",
    active: true
  }, {
    id: "02",
    title: "Brand Strategy & Restyle",
    description: "Identità visiva, tono, posizionamento e sistema narrativo.",
    active: false
  }, {
    id: "03",
    title: "Strategia Digitale",
    description: "Canali, obiettivi, contenuti e priorità operative.",
    active: false
  }];
  const productionServices = [{
    id: "04",
    title: "Social Media & Content",
    description: "Piano editoriale, format, rubriche e contenuti ricorrenti.",
    active: true
  }, {
    id: "05",
    title: "Fotografia di Brand",
    description: "Scatti per raccontare persone, luoghi, prodotti e atmosfera.",
    active: false
  }, {
    id: "06",
    title: "Video & Storytelling",
    description: "Video brevi, interviste, backstage e contenuti social.",
    active: false
  }];
  return <section data-section-id="2840" id="servicesgrid" className="bg-background text-foreground py-32 md:py-40 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-10 lg:px-20">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-[65%_35%] gap-12 mb-24 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div>
            <p className="font-mono text-[12px] tracking-[0.2em] uppercase mb-6 text-muted-foreground">
              § 02 // SERVIZI
            </p>
            <h2 className="font-default text-5xl md:text-7xl font-bold tracking-tighter leading-[1.1]">
              Comunicazione<br />che lavora.
            </h2>
          </div>
          <div className="flex items-end">
            <p className="font-default text-lg text-muted-foreground leading-relaxed">
              Sei servizi ordinati in due fasi: prima la direzione, poi la produzione. Meno rumore, più metodo, più risultati.
            </p>
          </div>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 lg:grid-cols-2 gap-8 transition-all duration-1000 ease-out delay-200 ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="space-y-6">
            <div className="flex items-center gap-4 mb-4">
              <span className="font-mono text-[10px] tracking-widest uppercase text-primary">Strategia</span>
              <div className="h-px flex-1 bg-border/50" />
            </div>
            
            <div className="space-y-4">
              {strategyServices.map((service, i) => <div key={service.id} data-index={i} className={`p-8 rounded-lg border transition-all duration-500 ${service.active ? "bg-card border-primary/30 shadow-lg" : "bg-card/50 border-border hover:border-primary/20"}`}>
                  <div className="flex justify-between items-start mb-4">
                    <div className="flex gap-6">
                      <span className="font-mono text-xs text-primary/60 mt-1">{service.id}</span>
                      <div>
                        <h3 className="text-2xl font-bold mb-2">{service.title}</h3>
                        <p className="text-muted-foreground text-sm leading-relaxed">{service.description}</p>
                      </div>
                    </div>
                    <div className={`size-8 rounded-lg flex items-center justify-center transition-colors ${service.active ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground"}`}>
                      {service.active ? <X className="size-4" /> : <Plus className="size-4" />}
                    </div>
                  </div>

                  {service.active && service.details && <div className="mt-8 pt-8 border-t border-border/50 space-y-6">
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        {['ANALISI', 'METODO', 'CREATIVITÀ'].map(label => <div key={label} className="space-y-2">
                            <span className="font-mono text-[10px] tracking-widest text-primary">{label}</span>
                            <div className="h-12 bg-muted/30 rounded-md border border-border/30" />
                          </div>)}
                      </div>
                      <div className="flex flex-wrap gap-2">
                        {['Essenziale', 'Avanzato + SEO', '360'].map((tag, idx) => <span key={tag} className={`px-4 py-1.5 rounded-lg text-[11px] font-medium ${idx === 0 ? "bg-primary text-primary-foreground" : "bg-muted/50 text-muted-foreground"}`}>
                            {tag}
                          </span>)}
                      </div>
                      <p className="text-xs text-muted-foreground italic">{service.details}</p>
                      <button className="text-xs font-bold uppercase tracking-widest border-b border-primary pb-1 hover:text-primary transition-colors">
                        Scegli il tuo livello di audit
                      </button>
                    </div>}
                </div>)}
            </div>
          </div>

          {}
          <div className="space-y-6">
            <div className="flex items-center gap-4 mb-4">
              <span className="font-mono text-[10px] tracking-widest uppercase text-primary">Produzione</span>
              <div className="h-px flex-1 bg-border/50" />
            </div>

            <div className="space-y-4">
              {productionServices.map((service, i) => <div key={service.id} data-index={i} className={`p-8 rounded-lg border transition-all duration-500 ${service.active ? "bg-card border-primary/30 shadow-lg" : "bg-card/50 border-border hover:border-primary/20"}`}>
                  <div className="flex justify-between items-start">
                    <div className="flex gap-6">
                      <span className="font-mono text-xs text-primary/60 mt-1">{service.id}</span>
                      <div>
                        <h3 className="text-2xl font-bold mb-2">{service.title}</h3>
                        <p className="text-muted-foreground text-sm leading-relaxed">{service.description}</p>
                      </div>
                    </div>
                    <div className={`size-8 rounded-lg flex items-center justify-center transition-colors ${service.active ? "bg-secondary text-secondary-foreground" : "bg-muted text-muted-foreground"}`}>
                      {service.active ? <X className="size-4" /> : <Plus className="size-4" />}
                    </div>
                  </div>

                  {service.active && <div className="mt-8 pt-8 border-t border-border/50 space-y-6">
                      <div className="space-y-4">
                        {['ANALISI', 'METODO', 'CREATIVITÀ'].map(label => <div key={label} className="space-y-2">
                            <span className="font-mono text-[10px] tracking-widest text-primary">{label}</span>
                            <div className="h-10 bg-muted/30 rounded-md border border-border/30" />
                          </div>)}
                      </div>
                      <button className="w-full py-3 rounded-lg bg-secondary/10 text-secondary text-xs font-bold uppercase tracking-widest hover:bg-secondary hover:text-secondary-foreground transition-all">
                        Gestiamo i tuoi social insieme
                      </button>
                    </div>}
                </div>)}
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 p-8 rounded-lg bg-card border border-border flex flex-col md:flex-row items-center justify-between gap-8">
          <div>
            <h4 className="text-xl font-bold mb-2">Non vendiamo pacchetti standard.</h4>
            <p className="text-muted-foreground text-sm">Ogni percorso parte da una diagnosi chiara e viene costruito sulle priorità reali della tua azienda.</p>
          </div>
          <button className="px-8 py-4 rounded-lg bg-primary text-primary-foreground font-bold text-sm uppercase tracking-widest hover:scale-[1.02] transition-transform">
            Richiedi preventivo
          </button>
        </div>
      </div>
    </section>;
}